<template>
	<div class="bg-white">
		<slot />
	</div>
</template>
